import { SystemRole } from 'modules/shared/roles';

// Define path names here
export enum RoutePaths {
    Offline = 'offline',
    StaffSSO = 'SSO',
    ConfirmAccount = 'confirmaccount',
    ConfirmAccount2 = 'confirm.aspx',
    PasswordReset = 'passwordreset',
    PasswordReset2 = 'reset.aspx',
    Home = 'home',
    Landing = 'landing',
    PCPSConnect = 'pcpsconnect',
    Interviews = 'interviews',
    JobBrowser = 'job-browser',
    /* Application Steps */
    ApplicationStatus = 'appstatus',
    PersonalInfo = 'personal',
    ContactInfo = 'contact',
    ApplicationType = 'apptype',
    EducationHistory = 'edhistory',
    EmploymentHistory = 'emphistory',
    WorkPerformance = 'workperformance',
    References = 'references',
    CriminalHistory = 'criminalhistory',
    ApplicantSurvey = 'survey',
    ProfessioanlQualifications = 'profqualifications',
    Certification = 'certification',
    InstructionalQualifications = 'instqualifications',
    Sanctions = 'sanctions',
    SubjectAreaExams = 'subjectareaexams',
    SubjectAreaInterest = 'subjectareainterest',
    StudentTeaching = 'studentteaching',
    ParaSurvey = 'parasurvey',
    CustodialSurvey = 'custodialsurvey',
    TeacherTransfer = 'teachertransfer',
    Transcripts = 'transcripts',
    ResumesCoverLetters = 'resumecoverletter',
}

// Define the roles which have access to each route listed above.
export const RouteRoles = {
    Home: [SystemRole.All],
    Landing: [SystemRole.All],
};

// Define menu button IDs here
export enum RouteMenus {
    Home = 1,
    MyApplication = 200,
    AppStatus = 201,
    AppPersonalInfo = 202,
    AppContactInfo = 203,
    AppAppType = 204,
    AppEdHistory = 205,
    AppEmpHistory = 206,
    AppWorkPerf = 207,
    AppReferences = 208,
    AppCriminalHistory = 209,
    AppApplicantSurvey = 210,
    AppProfQual = 211,
    AppCertification = 212,
    AppInstQual = 213,
    AppProfSanctions = 214,
    AppSubjectAreaExams = 215,
    AppSubjectAreaInterest = 216,
    AppStudentTeaching = 217,
    AppCustodialSurvey = 218,
    AppParaSurvey = 219,
    AppTeacherTransfer = 220,
    AppTranscripts = 221,
    AppResumesCoverLetters = 222,
    // MyTranscripts = 300,
    BrowseJobs = 400,
    MyInterviews = 500,
    HelpDocs = 600,
    HelpDocsHiring = 601,
    JobFairs = 700,
    PCPSConnect = 800,
    Logout = 9,
    About = 10,
}
